import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import SearchString from '../../../components/forPages/search/SearchString';
import _ from 'lodash';
import { TableString } from '@/pages/search/[search]';
import { ISearchPrep } from '@/types/search';
import useDeviceDetect from '../../../helpers/hooks';
import Modal from '../../../ui/Modal';
import ModalBlockedObjects from '../../ModalBlockedObjects';
import Image from 'next/image';

const CartIcon = '/img/icons/cart.png';

export interface ISortBy {
  iter: string,
  order: boolean | 'asc' | 'desc'
}

// 1. Меняем дефолтную сортировку на relevance_rank (от сервера)
const defaultSort: ISortBy = { iter: 'relevance_rank', order: 'asc' };

export default function SearchProducts({
                                         preps,
                                         sortByPrice = false
                                       }: {
  preps: ISearchPrep[];
  searchString: string;
  sortByPrice?: boolean;
}){
  const [ openModal, setOpenModel ] = useState(0);
  const [ sortBy, setSortBy ] = useState<ISortBy>(defaultSort);
  const { isMobile } = useDeviceDetect();

  useEffect(() => {
    if(isMobile) {
      if(sortByPrice && sortBy.iter !== 'min_price') {
        setSortBy({ iter: 'min_price', order: 'asc' });
      } else if(!sortByPrice && sortBy.iter !== 'relevance_rank') {
        // 2. Переключаем мобильный дефолт на relevance_rank
        setSortBy({ iter: 'relevance_rank', order: 'asc' });
      }
    }
  }, [sortByPrice, sortBy, isMobile]);

  const openObjectsModal = (prepId: number) => { setOpenModel(prepId); };
  const closeObjectsModal = () => setOpenModel(0);

  const handleSort = (item: string) => {
    if (sortBy.iter === item) {
      setSortBy((prevState) => ({
        ...prevState,
        order: prevState.order === 'asc' ? 'desc' : 'asc'
      }));
    } else {
      setSortBy({ iter: item, order: 'asc' });
    }
  };

  const sortIters: (keyof ISearchPrep | string)[] = ['is_synonim', sortBy.iter];
  const sortOrders: ('asc' | 'desc')[] = ['asc', sortBy.order as 'asc' | 'desc'];
// В режиме релевантности цена — тай-брейкер перед алфавитом:
// сначала аналог/оригинал, потом релевантность, потом цена, потом имя.
// В режиме цены релевантность полностью игнорируется.
  if (sortBy.iter === 'relevance_rank') {
    sortIters.push('min_price');
    sortOrders.push('asc');
  }
  sortIters.push('rcfi_name');
  sortOrders.push('asc');
  const sortedPreps = _.orderBy(preps, sortIters, sortOrders);

  if(!isMobile) {
    return <>
      <Products key="desktop-products">
        <TableString className="first-table-string" key="0">
          <div></div>
          <div>Наименование</div>
          <div className="sorting">
            <a onClick={() => handleSort('min_price')}>
              Цена&nbsp;&nbsp;
              {sortBy.iter === 'min_price' && sortBy.order === 'asc' && <ToHight>&#9650;</ToHight>}
              {sortBy.iter === 'min_price' && sortBy.order === 'desc' && <ToLow>&#9660;</ToLow>}
            </a>
          </div>
          <div>Аптеки</div>
          <div>Добавить</div>
          <div><Image src={CartIcon} alt="Корзина" width={31} height={28}/></div>
        </TableString>

        {sortedPreps.map((prep) => {
          return <SearchString key={'a'+prep.id} prep={prep} openObjectsModal={openObjectsModal} />
        })}
      </Products>
      {openModal && <Modal><ModalBlockedObjects onClose={closeObjectsModal} prepId={openModal} /></Modal>}
    </>
  }

  return <>
    {sortedPreps.map((prep) => {
      return <SearchString key={prep.id} prep={prep} openObjectsModal={openObjectsModal} />
    })}
    {openModal && <Modal><ModalBlockedObjects onClose={closeObjectsModal} prepId={openModal} /></Modal>}
  </>
}

const ToHight = styled.span`
  transform: translateY(-1px);
`
const ToLow = styled.span`
  transform: translateY(-1px);
`

const Products = styled.div`
  display: grid;
  white-space: initial;

  @media (max-width: 480px) {
    padding: 0;
    display: block;
  }
`